import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DiscussionService } from '../../../../shared-service/services/discussion.service';
@Component({
  selector: 'comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.css']
})
export class CommentListComponent implements OnInit {

  @Input()
  comment:any;

  discuss_id:any;
  results:any;
  totalComments:any;
  showReplies=false;
  showCommentBox=false;
  postReplyId:any;
  userId='';
  userData:any;
  profileUrl ='';
  customProfileName='';
  colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];
  colorPick = '';
  constructor(
    private route: ActivatedRoute,
    public discussionService: DiscussionService,
  ) { }

  ngOnInit() {
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
    this.discuss_id = this.comment.forum_id;
   // this.postReplyId = this.comment.id;
   this.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
    this.postReplyId = "comment-reply-"+this.comment.id+"-sub";
    // this.discussionService.getCommentByDiscussionId(this.discuss_id).subscribe(
    //   (res:any) => {
    //     this.results = res.data;
    //     this.totalComments = res.count;
    //   }
    // );
  }

  viewReplies() {
    this.showReplies=!this.showReplies;
  }

  viewCommentBox() {
    this.showCommentBox=true;
    if(this.showReplies) {
      var elmnt = document.getElementById("comment-box-"+ this.comment.id);
      elmnt.focus();
    } else {
      setTimeout(()=> {
        var elmnt = document.getElementById("comment-box-"+ this.comment.id);
        elmnt.focus();
      })
    }
  }

  showRepliesSection() {
    this.showReplies=true;
    this.showCommentBox=false;
  }

  addRemoveUpvote(forum_id, post_type){
    var formData:any = new FormData();
    formData.append('discussion_type', 'comment');
    formData.append('discussion_id', this.comment.id);
    formData.append('user_id', this.userId);


    console.log(forum_id +'---'+ post_type);
    this.discussionService.addRemoveUpvote(formData).subscribe((result:any) => {
      if(result && result.data && result.data.totlikeData != false) {
        this.comment.totLikes=result.data.totlikeData;
      } else if(this.comment.totLikes != 0) {
        this.comment.totLikes = this.comment.totLikes-1;
      }
    })
  }

}
